var $window = $(window);
var breakPoint = 1024;

var resizeFlag = false;
var windowWidth = $window.width();
var windowHeight = $window.height();

//ローディング
import {loading} from "../include/module";
loading();

//ヘッダーの開閉
import {headerToggle} from "../include/module";
headerToggle();

//ページ内リンクのアニメーション
import {anchorScroll} from "../include/module";
anchorScroll();

// preload
import {preload} from "../include/module";
preload();

// resizing
import {resizing} from "../include/module";
resizing();

// アニメーション
import {animationFire} from "../include/module";
animationFire();

// カテゴリーの長さ
const goodsCategory = () => {
  const $target = $('.goods-Category').children('ul');
  const list = $target.find('li');

  // liの合計値
  const listArray = [];
  for (var i = 0; i < list.length; i++) {
    listArray.push(Math.ceil(list.eq(i).width() + 2));
  }
  const sum  = function(arr) {
    return arr.reduce(function(prev, current, i, arr) {
      return prev+current;
    });
  };
  const listSum = sum(listArray);

  // marginの合計値
  const ww = $window.width();
  const margin = Math.ceil(ww * (40 / 1024));
  const marginSum = Math.ceil(margin * (list.length - 1));

  // liとmarginの合計値
  const listWidth = listSum + marginSum;

  $target.css('width', listWidth);

};

$(document).ready(function(){
  if(windowWidth > breakPoint){
  }else{
    goodsCategory();
  }
  var timer = false;
  $(window).on('resize',function() {
    var resizeWidth = $(window).width();
    clearTimeout(timer);
    timer = setTimeout(function() {
      if(windowWidth != resizeWidth){
        if(resizeWidth > breakPoint){
          $('.goods-Category').children('ul').css('width', '');
        }else{
          goodsCategory();
        }
      }
      windowWidth = resizeWidth;
    }, 100);
  });
});


// WEBPACK FOOTER //
// ./src/assets/js/goods/script.js